module.exports = __webpack_public_path__ + "static/logo512-4d493aa77afa422d631d1f80d55edda6.png";